import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import TimeCardView from "./TimeCardView";
import ReportTimeCardView from './ReportTimeCardView';
const BilableTab = (props) => {

    return (
        <Fragment>
            <div className='report-header-container'>
                <div className='report-leave-container'>
                    {/* {props.configLeave?.filter_option_id == 1 ?
                        <button
                            className="add-report-leave-btn"
                            onClick={() => props.leaveHandler()}
                        >Add Leave</button> : null} */}
                    <button
                        className="add-report-leave-btn"
                        onClick={() => props.addManualEntryHandler()}
                    >Manual Entry</button>
                </div>
                {props.data && Object.keys(props.data).length > 0 ?
                    <div className='report-header'>
                        <button
                            type='button'
                            className='me-2'
                            onClick={() => props.reportHandler()}
                        >Save & Submit</button>

                        <button
                            type='button'
                            onClick={() => props.saveHandler()}
                        >Save</button>
                    </div>
                    : null}
            </div>
            {
                props.data && Object.keys(props.data).length > 0 ? (
                    <ReportTimeCardView
                        onNoteHandler={(id) => props.noteHandler(id)}
                        isConfig={props.config}
                        projectName=""
                        details={props.data ?? null}
                    />
                ) : (
                    <div className="text-center mt-3">
                        <h3>No Data Found</h3>
                    </div>
                )
            }
            {/* {
                props.data?.length > 0 ?
                    props.data.map((item, index) => {
                        return (
                            <TimeCardView
                                key={index}
                                onNoteHandler={(id) => props.noteHandler(id)}
                                isConfig={props.config}
                                projectName={item?.project_name}
                                details={item?.report_data[0]} />
                        )
                    })
                    :
                    <div className='text-center mt-3'><h3>No Data Found</h3></div>
            } */}

        </Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.timeCapture.screenVisible,
        configLeave: state.systemconfig.leaveConfig,
    };
};
export default connect(mapStateToProps)(BilableTab);